import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import EntitlementsPage, { getDefaultUI } from "components/pages/EntitlementsPage";

/**
 * @name CaptureEntitlementsMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureEntitlementsMain(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "userAddedBanner", "isActive" ], false)
    .submit();

    return <EntitlementsPage ui={ ui } />;
}